import { createFileRoute } from "@tanstack/react-router"

import { DesktopPlanner } from "@/crm/components/planner/desktop/planner"
import { MobilePlanner } from "@/crm/components/planner/mobile/planner"
import { Adaptive } from "@/crm/lib/viewport"

export const Route = createFileRoute("/_crm/planner")({
  component: PlannerRoute,
})

function PlannerRoute() {
  return <Adaptive desktop={<DesktopPlanner />} mobile={<MobilePlanner />} />
}
